import React from "react";
import { useTranslation } from "react-i18next";
import "./loyaltyProgramDetails.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faGift, faShoppingCart } from "@fortawesome/pro-regular-svg-icons";
import { ButtonNew as Button } from "components/buttonNew";
import useModal from "hooks/modals/useModal";
import Portal from "elements/Portal";
import Sheet from "components/sheet/Sheet";
import { ILoyaltyProgram } from "redux/reducers/models/loyalty";
import Markdown from "components/markdown/Markdown";
import { useAppSelector } from "hooks/redux";

interface IProps {
    loyaltyProgram: ILoyaltyProgram;
}

export default function LoyaltyProgramDetails(props: IProps) {
    const {loyaltyProgram} = props;
    const {facilityStore} = useAppSelector(store => store);
    const {t} = useTranslation();
    const {
        state: termsModal,
        closeModal: closeTermsModal,
        updateModal: updateTermsModal,
      } = useModal();

    return (
        <div>
            {/* Display on customer side */}
            {!facilityStore?.loyaltyProgram ? (
                <>
                    <h1>{t("Description")}</h1>
                    <br />
                    <p className="loyalty-program-details-secondary">{loyaltyProgram?.welcome_text}</p>
                    <br />
                </>
            ) : null}
            <h1>{t("How to Earn Points")}</h1>
            <br />
            <div className="loyalty-program-details">
                <div className="loyalty-program-details-card">
                    <div className="loyalty-program-details-icon">
                        <FontAwesomeIcon icon={faShoppingCart} />
                    </div>
                    <div>
                        <p className="loyalty-program-details-primary">{t("Order & Pay")}</p>
                        <p className="loyalty-program-details-secondary">{t("Let the staff know you want to earn points on your order.")}</p>
                    </div>
                </div>
                <div className="loyalty-program-details-card">
                    <div className="loyalty-program-details-icon">
                        <FontAwesomeIcon icon={faCirclePlus} />
                    </div>
                    <div>
                        <p className="loyalty-program-details-primary">{t("Earn Points")}</p>
                        <p className="loyalty-program-details-secondary">{t("Accrue points for every dollar you spend on valid products.")}</p>
                    </div>
                </div>
                <div className="loyalty-program-details-card">
                    <div className="loyalty-program-details-icon">
                        <FontAwesomeIcon icon={faGift} />
                    </div>
                    <div>
                        <p className="loyalty-program-details-primary">{t("Use Rewards")}</p>
                        <p className="loyalty-program-details-secondary">{t("Spend your points for rewards when completing an order.")}</p>
                    </div>
                </div>
            </div>
            <br />

            {/* Display on customer side */}
            {!facilityStore?.loyaltyProgram ? (
                <div className="w-full flex justify-center">
                <Button size="medium" type="text" onClick={() => updateTermsModal({isOpen: true})}>{t("View Terms and Conditions")}</Button>
                </div>
            ) : null}
            
            <Portal isMounted={termsModal?.isOpen}>
                <Sheet
                open={termsModal?.isOpen}
                title={t("Terms and Conditions")}
                size="small"
                onCancel={closeTermsModal}
                >
                    <Markdown markdownText={loyaltyProgram?.terms} />
                </Sheet>
            </Portal>
        </div>
    );
}